import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


export class NewOfferteData {
  offertenummer: number;
}


@Component({
  selector: 'app-new-offerte',
  templateUrl: './new-offerte.component.html',
  styleUrls: ['./new-offerte.component.less']
})
export class NewOfferteComponent implements OnInit {


  public data = new NewOfferteData();

  constructor(
    public dialogRef: MatDialogRef<NewOfferteComponent>,
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
